// extracted by mini-css-extract-plugin
module.exports = {"video-container":"VideoPlayer_video-container__QZ65c","player":"VideoPlayer_player__LVscH","bunny-player":"VideoPlayer_bunny-player__b39Nb"};